var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 340",
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f5f9",
    fillOpacity: 0.33,
    d: "M0,224L60,224C120,224,240,224,360,197.3C480,171,600,117,720,106.7C840,96,960,128,1080,165.3C1200,203,1320,245,1380,266.7L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,10)",
    fill: "#f2f5f9",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,224L60,224C120,224,240,224,360,197.3C480,171,600,117,720,106.7C840,96,960,128,1080,165.3C1200,203,1320,245,1380,266.7L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,20)",
    fill: "#f2f5f9",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,224L60,224C120,224,240,224,360,197.3C480,171,600,117,720,106.7C840,96,960,128,1080,165.3C1200,203,1320,245,1380,266.7L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveHome);
export default __webpack_public_path__ + "static/media/wave-home.8099da2c58ed26a97b503ff4b6014e99.svg";
export { ForwardRef as ReactComponent };